/**
 * Create Lesson illustration — miniature wireframe of the CreateBox:
 * textarea with placeholder text, suggestion chips, paperclip attach, generate button.
 */
import type { IllustrationProps } from './types';
import { usePalette } from './types';

export function CreateLesson({ variant = 'on-gradient', className, style }: IllustrationProps) {
  const p = usePalette(variant);

  return (
    <svg
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Card frame */}
      <rect
        x="4"
        y="4"
        width="112"
        height="112"
        rx="10"
        fill={p.frameFill}
        stroke={p.frameStroke}
        strokeWidth="1"
      />

      {/* "Create" eyebrow label */}
      <rect x="14" y="14" width="28" height="3" rx="1.5" fill={p.medium} />

      {/* Textarea area — 3 lines of placeholder text */}
      <rect x="14" y="26" width="78" height="3.5" rx="1.75" fill={p.subtle} />
      <rect x="14" y="33" width="60" height="3.5" rx="1.75" fill={p.faint} />
      <rect x="14" y="40" width="45" height="3.5" rx="1.75" fill={p.faint} />

      {/* Divider line */}
      <rect x="14" y="54" width="92" height="0.75" rx="0.375" fill={p.cardStroke} />

      {/* Paperclip attach circle */}
      <circle cx="22" cy="68" r="7" fill={p.cardFill} stroke={p.cardStroke} strokeWidth="0.75" />
      {/* Clip icon — simplified diagonal line */}
      <line
        x1="19.5"
        y1="70.5"
        x2="24.5"
        y2="65.5"
        stroke={p.medium}
        strokeWidth="1.2"
        strokeLinecap="round"
      />

      {/* Suggestion chips */}
      <rect
        x="34"
        y="62"
        width="32"
        height="12"
        rx="6"
        fill={p.cardFill}
        stroke={p.cardStroke}
        strokeWidth="0.75"
      />
      <rect x="39" y="67" width="22" height="2.5" rx="1.25" fill={p.subtle} />

      <rect
        x="70"
        y="62"
        width="28"
        height="12"
        rx="6"
        fill={p.cardFill}
        stroke={p.cardStroke}
        strokeWidth="0.75"
      />
      <rect x="75" y="67" width="18" height="2.5" rx="1.25" fill={p.subtle} />

      <rect
        x="34"
        y="78"
        width="36"
        height="12"
        rx="6"
        fill={p.cardFill}
        stroke={p.cardStroke}
        strokeWidth="0.75"
      />
      <rect x="39" y="83" width="26" height="2.5" rx="1.25" fill={p.subtle} />

      {/* Generate button — gradient pill */}
      <rect x="74" y="78" width="32" height="12" rx="6" fill={p.buttonFill} />
      {/* Arrow up icon */}
      <path
        d="M88 86 L90 83.5 L92 86"
        stroke={p.buttonText}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="90"
        y1="84"
        x2="90"
        y2="88"
        stroke={p.buttonText}
        strokeWidth="1.2"
        strokeLinecap="round"
      />

      {/* "Generate" text */}
      <rect x="78" y="83" width="8" height="2" rx="1" fill={p.buttonText} />
    </svg>
  );
}
